module.exports = __webpack_public_path__ + "static/media/am_account-details.76a44be4.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/am_account-details.md
// module id = 1085
// module chunks = 0